import { getProp } from 'mol-ui';
import styled from 'styled-components';

export const CardWrapper = styled.div.attrs(props => ({
    style: {
        cursor: props.cursor,
        left: props.left,
        top: props.top
    }
}))`
    position: absolute;
    z-index: ${ getProp('zIndex') };
`;

export const IconContainer = styled.div`
    position: absolute;
    right: 2px;
    top: 2px;
    z-index: 1px;
`;
